import {Api, ApiExport} from '../../../Api.js'

const RESOURCE = 'invoice'

export default {
    resource: RESOURCE,
    all(query) {
        return Api().get(this.resource + '/all')
    },
    query(query) {
        return Api().get(this.resource + (query ? query : ''))
    },
    get(id) {
        return Api().get(this.resource + '/' + id)
    },
    create(data) {
        return Api().post(this.resource, data)
    },
    update(id, data) {
        return Api().put(this.resource + '/' + id, data)
    },
    delete(id) {
        return Api().delete(this.resource + '/' + id)
    },
    getStatsByCustomers(period,branch,date=null) {
        return Api().get(this.resource + '/stats/customers?period=' + period + '&date=' + date + '&branch=' + branch)
    },
    getStatsByUsers(period,branch,date=null) {
        return Api().get(this.resource + '/stats/users?period=' + period + '&date=' + date + '&branch=' + branch)
    },
    getStats(period,branch=null,date=null) {
        return Api().get(this.resource + '/stats?period=' + period + '&date=' + date + '&branch=' + branch)
    },
    getStatsAquisition(type, period, branch=null,date=null) {
        return Api().get(this.resource + '/stats/aquisition?type=' + type + '&period=' + period + '&date=' + date + '&branch=' + branch)
    },
    getStatsUserAquisition(type, period, branch=null,date=null) {
        return Api().get(this.resource + '/stats/aquisition-user?type=' + type + '&period=' + period + '&date=' + date + '&branch=' + branch)
    },
    getStatsAquisitionCohort(type, period, branch=null,date=null) {
        return Api().get(this.resource + '/stats/aquisition-cohort?type=' + type + '&period=' + period + '&date=' + date + '&branch=' + branch)
    },
    getStatsCompare(period,branch=null,date=null) {
        return Api().get(this.resource + '/stats/compare?type=' + period + '&date=' + date + '&branch=' + branch)
    },
    getStatsResume(period,branch=null,date=null) {
        return Api().get(this.resource + '/stats/resume?period=' + period + '&date=' + date + '&branch=' + branch)
    },
    getBranchStats(period,date=null) {
        return Api().get(this.resource + '/branch/stats?period=' + period + '&date=' + date)
    },
    calculate(data) {
        return Api().post(this.resource + '/calculate', data)
    },
    import(data) {
        return Api().post(this.resource + '/import', data)
    },
    export(query, filename) {

        /*
        return window.axios({
            url: window.axios.defaults.baseURL + '/' + this.resource + '/export' + (query ? query : ''),
            method: 'GET',
            responseType: 'blob', // important
        });*/

        return ApiExport(filename).get(this.resource + '/export' + (query ? query : ''),
            {
                responseType: 'blob', // important
            });

    },
    exportForBanana(query, filename) {

        return ApiExport(filename).get(this.resource + '/export-banana' + (query ? query : ''),
            {
                responseType: 'blob', // important
            });

    },
}


// WEBPACK FOOTER //
// ./src/modules/invoicing/invoice/InvoiceService.js